import type React from "react";
import { useEffect, useMemo, useRef } from "react";

import JsBarcode from "jsbarcode";

import styles from "./Barcode.module.scss";

type BarcodeProps = {
  value: string;
  displayValue?: boolean;
  margin?: number;
  width?: number;
  height?: number;
  background?: string;
  fontSize?: number;
  textMargin?: number;
};

export const Barcode: React.FC<BarcodeProps> = ({
  value,
  displayValue = false,
  margin = 10,
  width = 2,
  height = 100,
  background = "transparent",
  fontSize = 20,
  textMargin = 10,
}) => {
  const svgRef = useRef<SVGSVGElement>(null);

  const barcodeOptions = useMemo(
    () => ({
      format: "CODE128",
      displayValue,
      margin,
      width,
      height,
      background,
      fontSize,
      textMargin,
    }),
    [displayValue, margin, width, height, background, fontSize, textMargin]
  );

  useEffect(() => {
    if (svgRef.current) {
      try {
        JsBarcode(svgRef.current, value, barcodeOptions);
      } catch (error) {
        console.error(error);
      }
    }
  }, [value, barcodeOptions]);

  return <svg data-testid="barcodeSvg" ref={svgRef} className={styles.barcodeSvg} />;
};
